<template>
    <div>
        <ValidationObserver ref="form">
            <b-row>
                <b-col cols="12" md="4">
                    <ValidationProvider name="program_code" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('program') + ' *'">
                            <program-selectbox
                                :validateError="errors[0]"
                                v-model="filter.program_code"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="3">
                    <ValidationProvider name="student_status" rules="" v-slot="{errors}">
                        <b-form-group :label="$t('student_status')">
                            <parameter-selectbox
                                code="student_statuses"
                                :validateError="errors[0]"
                                v-model="filter.student_status"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group>
                        <label class="d-none d-md-block">&nbsp;</label>
                        <b-form-checkbox v-model="filter.merge_equal_items" :value="1" :unchecked-value="0">
                            {{ $t('merge_equal_items') }}
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="2">
                    <b-form-group class="mb-0">
                        <label class="d-none d-md-block">&nbsp;</label>
                        <processing-button @click="getReport" label="get_report" :processing="processing"/>
                    </b-form-group>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ProcessingButton from '@/components/elements/ProcessingButton'
import StudentReportService from '@/services/StudentReportService'
import qs from 'qs'

export default {
    name: 'EctsStudentReport',
    components: {
        ValidationObserver,
        ValidationProvider,
        ProcessingButton
    },
    data() {
        return {
            processing: false,
            filter: {
                program_code: null,
                student_status: null,
                merge_equal_items: 0
            }
        }
    },
    methods: {
        async getReport() {
            const isValid = await this.$refs.form.validate()
            if (!isValid) return

            this.processing = true

            const cleanFilter = {};
            Object.keys(this.filter).forEach(key => {
                let val = this.filter[key];
                if (val !== null && val !== undefined && val !== '' && val !== false && val !== 0) {
                    if (val === true) {
                        val = 1;
                    }
                    cleanFilter[key] = val;
                }
            });

            const config = {
                params: {
                    filter: cleanFilter
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }

            return StudentReportService.ectsStudentReport(config)
                .then((response) => {
                    this._downloadFile(response, this.$t('ects_student_report') + '.xlsx')
                })
                .catch((error) => {
                    this.showErrors(error, this.$refs.form, true)
                })
                .finally(() => {
                    this.processing = false
                })
        }
    }
}
</script>
